/** Spanish card titles for Analysis (RFP Discovery Scope) only. */

export const SCOPE_FIELD_LABELS_ES = {
  "design.ddos.project_type_cloud_onprem_hybrid": "Tipo de proyecto DDoS",
  "design.ddos.cloud.diversion_type": "Tipo de desvío DDoS cloud",
  "design.ddos.cloud.mitigation_capacity": "Capacidad de mitigación cloud",
  "design.ddos.cloud.legitimate_traffic_throughput": "Throughput legítimo cloud",
  "design.ddos.cloud.customer_has_own_as": "AS propio del cliente",
  "design.ddos.cloud.number_of_networks_to_protect": "Redes a proteger",
  "design.ddos.cloud.dns_diversion_assets": "Activos de desvío DNS",
  "design.ddos.cloud.dns_ddos_protection_required": "Protección DNS DDoS",
  "design.ddos.cloud.https_flood_protection_required": "Protección HTTPS flood",
  "design.ddos.cloud.management_visibility_features": "Gestión DDoS cloud",
  "design.ddos.cloud.reporting_needs": "Reportes DDoS cloud",
  "design.ddos.cloud.logs_needs": "Logs DDoS cloud",
  "design.ddos.cloud.storage_retention_needs": "Retención DDoS cloud",
  "design.ddos.onprem.number_of_equipment": "Cantidad de equipos DDoS",
  "design.ddos.onprem.ha_requirements": "Requisitos de HA DDoS",
  "design.ddos.onprem.deployment_mode": "Modo de despliegue DDoS",
  "design.ddos.onprem.mitigation_throughput": "Throughput de mitigación DDoS",
  "design.ddos.onprem.legitimate_traffic_throughput": "Throughput legítimo DDoS",
  "design.ddos.onprem.interfaces_and_type": "Interfaces DDoS",
  "design.ddos.onprem.power_supply": "Fuente de poder DDoS",
  "design.ddos.onprem.bypass_requirements": "Bypass",
  "design.ddos.onprem.cps_pps_concurrent_connections": "CPS/PPS DDoS",
  "design.ddos.onprem.dns_ddos_protection_required": "DNS DDoS on-prem",
  "design.ddos.onprem.https_flood_protection_required": "HTTPS flood on-prem",
  "design.ddos.onprem.management_visibility_features": "Gestión DDoS on-prem",
  "design.ddos.onprem.reporting_needs": "Reportes DDoS on-prem",
  "design.ddos.onprem.logs_needs": "Logs DDoS on-prem",
  "design.ddos.onprem.storage_retention_needs": "Retención DDoS on-prem",
  "design.alteon.number_of_equipment": "Cantidad de equipos Alteon",
  "design.alteon.ha_requirements": "HA Alteon",
  "design.alteon.throughput_l4": "Throughput L4 Alteon",
  "design.alteon.throughput_l7": "Throughput L7 Alteon",
  "design.alteon.interfaces_and_type": "Interfaces Alteon",
  "design.alteon.ram_disk": "RAM/disco Alteon",
  "design.alteon.power_supply": "Fuente de poder Alteon",
  "design.alteon.cps_pps_concurrent_connections": "CPS/PPS Alteon",
  "design.alteon.ssl_capacity": "Capacidad SSL Alteon",
  "design.alteon.compression_throughput": "Throughput de compresión",
  "design.alteon.virtual_instances_partitions_route_domains": "Instancias virtuales",
  "design.alteon.security_features": "Características de seguridad",
  "design.alteon.management_visibility_features": "Gestión Alteon",
  "design.alteon.reporting_needs": "Reportes Alteon",
  "design.alteon.logs_needs": "Logs Alteon",
  "design.alteon.storage_retention_needs": "Retención Alteon",
  "design.application_security.deployment_model_cloud_onprem_both": "Modelo de despliegue AppSec",
  "design.application_security.onprem_deployment_mode": "Modo on-prem AppSec",
  "design.application_security.ha_requirements": "HA AppSec",
  "design.application_security.throughput_l4": "Throughput L4",
  "design.application_security.throughput_l7": "Throughput L7",
  "design.application_security.interfaces_and_type": "Interfaces AppSec",
  "design.application_security.ram_disk": "RAM/disco AppSec",
  "design.application_security.power_supply": "Fuente de poder AppSec",
  "design.application_security.cps_pps_concurrent_connections": "CPS/PPS AppSec",
  "design.application_security.ssl_capacity": "Capacidad SSL AppSec",
  "design.application_security.number_of_applications": "Cantidad de aplicaciones",
  "design.application_security.number_of_apis": "Cantidad de APIs",
  "design.application_security.api_discovery_required": "Descubrimiento de APIs",
  "design.application_security.api_special_features": "Funciones especiales de API",
  "design.application_security.bot_manager_required": "Gestión de bots",
  "design.application_security.sophisticated_bot_requirement_1": "Requisito avanzado de bots 1",
  "design.application_security.sophisticated_bot_requirement_2": "Requisito avanzado de bots 2",
  "design.application_security.client_side_protection_required": "Protección del lado del cliente",
  "design.application_security.pci_certification_capabilities_required": "Capacidades PCI",
  "design.application_security.llm_firewall_required": "Firewall LLM",
  "design.application_security.ddos_requested_and_capacity": "DoS/DDoS AppSec y capacidad",
  "design.application_security.l7_ddos_requested": "DoS/DDoS L7",
  "design.application_security.management_visibility_features": "Gestión y visibilidad",
  "design.application_security.logs_needs": "Logs AppSec",
  "design.application_security.storage_retention_needs": "Retención AppSec",
  "design.application_security.reporting_needs": "Reportes AppSec",
  "design.application_security.ai_special_capabilities": "Capacidades de IA",
  "design.application_security.cdn_requirements": "Requerimientos de CDN",
  "design.application_security.dns_hosted_zones": "Zonas DNS hospedadas",
  "design.application_security.dns_queries_per_month": "Consultas DNS mensuales",
  "design.application_security.api_calls_or_requests_per_month": "Solicitudes API mensuales",
  "design.application_security.monthly_traffic_volume_tb_gb": "Volumen de tráfico mensual",
  "design.application_security.total_http_https_requests_per_month": "Solicitudes HTTP/HTTPS mensuales",
  "design.global_management.centralized_management_required": "Gestión centralizada",
  "design.global_management.management_platform": "Plataforma de gestión",
  "design.global_management.managed_technologies": "Tecnologías gestionadas",
  "design.global_management.deployment_model": "Modelo de despliegue",
  "design.global_management.ha_requirements": "HA de gestión",
  "design.global_management.visibility_features": "Visibilidad",
  "design.global_management.reporting_needs": "Reportes de gestión",
  "design.global_management.logs_needs": "Logs de gestión",
  "design.global_management.storage_retention_needs": "Retención de gestión",
  "design.global_management.event_correlation": "Correlación de eventos",
  "design.global_management.forensic_analysis": "Análisis forense",
  "design.global_management.rbac_or_user_roles": "RBAC / roles de usuario",
  "design.global_management.audit_trail": "Trazabilidad / auditoría",
  "design.global_management.integrations": "Integraciones",
  "design.global_management.admin_access_and_resilience": "Acceso administrativo y resiliencia",
  "design.global_management.licensing_or_scope_limits": "Licenciamiento o límites de alcance",
  "design.global_management.detection.flows_per_second": "Flujos por segundo",
  "design.global_management.detection.routers_to_monitor": "Routers a monitorear",
  "design.global_management.detection.flow_protocols": "Protocolos de flujo",
  "design.global_management.detection.prefixes_and_objects": "Prefijos y objetos",
  "design.global_management.detection.traffic_visibility_and_analytics": "Visibilidad y analítica de tráfico",
  "design.global_management.detection.diversion_methods": "Métodos de desvío",
  "sti.support.number_of_years": "Periodo de soporte",
  "sti.support.rma_replacement_time": "Tiempo de reemplazo RMA",
  "sti.support.under_attack_support_sla": "SLA bajo ataque",
  "sti.support.solution_availability": "Disponibilidad de la solución",
  "sti.support.support_availability": "Disponibilidad de soporte",
  "sti.support.special_customer_service_tam_csm_vendor_engineer": "Servicio especial al cliente",
  "sti.training.certified_or_knowledge_transfer": "Tipo de entrenamiento",
  "sti.training.onsite_or_online": "Modalidad de entrenamiento",
  "sti.training.customer_facilities": "Lugar del entrenamiento",
  "sti.training.number_of_people": "Participantes",
  "sti.training.number_of_sessions": "Sesiones de entrenamiento",
  "sti.implementation.vendor_implementation_required": "Implementación del fabricante",
  "sti.implementation.documentation_needs": "Documentación de implementación",
  "sti.implementation.attack_tests_required": "Pruebas de ataque",
  "sti.implementation.attack_test_requirements": "Requisitos de pruebas de ataque",
  "sti.implementation.vendor_engineer_certification_required": "Certificación del ingeniero del fabricante",
  "sti.implementation.partner_engineer_certification_required": "Certificación del ingeniero partner",
  "sti.implementation.delivery_timeline": "Cronograma de entrega",
  "commercial_admin.equipment_delivery_times": "Tiempos de entrega",
  "commercial_admin.payment_terms": "Condiciones de pago",
  "commercial_admin.special_contractual_requirements": "Requisitos contractuales",
  "commercial_admin.acquisition_process_dates": "Fechas del proceso de adquisición",
  "commercial_admin.penalties": "Penalidades",
  "commercial_admin.offer_validity": "Validez de la oferta",
  "commercial_admin.quote_submission_requirements": "Requisitos de cotización",
  "design.design_gaps": "Brechas de diseño",
  "sti.sti_gaps": "Brechas de soporte / entrenamiento / implementación",
  "commercial.commercial_admin_gaps": "Brechas comerciales / administrativas",
};

export const GAP_AREA_LABELS_ES = {
  Design: "Diseño",
  "Support / Training / Implementation": "Soporte / Entrenamiento / Implementación",
  "Commercial / Administrative": "Comercial / Administrativo",
};

export const SCOPE_FIELD_LABELS_PT = {
  "design.ddos.project_type_cloud_onprem_hybrid": "Tipo de projeto DDoS",
  "design.ddos.cloud.diversion_type": "Tipo de desvio DDoS cloud",
  "design.ddos.cloud.mitigation_capacity": "Capacidade de mitigação cloud",
  "design.ddos.cloud.legitimate_traffic_throughput": "Throughput legítimo cloud",
  "design.ddos.cloud.customer_has_own_as": "AS próprio do cliente",
  "design.ddos.cloud.number_of_networks_to_protect": "Redes a proteger",
  "design.ddos.cloud.dns_diversion_assets": "Ativos de desvio DNS",
  "design.ddos.cloud.dns_ddos_protection_required": "Proteção DNS DDoS",
  "design.ddos.cloud.https_flood_protection_required": "Proteção HTTPS flood",
  "design.ddos.cloud.management_visibility_features": "Gestão DDoS cloud",
  "design.ddos.cloud.reporting_needs": "Relatórios DDoS cloud",
  "design.ddos.cloud.logs_needs": "Logs DDoS cloud",
  "design.ddos.cloud.storage_retention_needs": "Retenção DDoS cloud",
  "design.ddos.onprem.number_of_equipment": "Quantidade de equipamentos DDoS",
  "design.ddos.onprem.ha_requirements": "Requisitos de HA DDoS",
  "design.ddos.onprem.deployment_mode": "Modo de implantação DDoS",
  "design.ddos.onprem.mitigation_throughput": "Throughput de mitigação DDoS",
  "design.ddos.onprem.legitimate_traffic_throughput": "Throughput legítimo DDoS",
  "design.ddos.onprem.interfaces_and_type": "Interfaces DDoS",
  "design.ddos.onprem.power_supply": "Fonte de alimentação DDoS",
  "design.ddos.onprem.bypass_requirements": "Bypass",
  "design.ddos.onprem.cps_pps_concurrent_connections": "CPS/PPS DDoS",
  "design.ddos.onprem.dns_ddos_protection_required": "DNS DDoS on-prem",
  "design.ddos.onprem.https_flood_protection_required": "HTTPS flood on-prem",
  "design.ddos.onprem.management_visibility_features": "Gestão DDoS on-prem",
  "design.ddos.onprem.reporting_needs": "Relatórios DDoS on-prem",
  "design.ddos.onprem.logs_needs": "Logs DDoS on-prem",
  "design.ddos.onprem.storage_retention_needs": "Retenção DDoS on-prem",
  "design.alteon.number_of_equipment": "Quantidade de equipamentos Alteon",
  "design.alteon.ha_requirements": "HA Alteon",
  "design.alteon.throughput_l4": "Throughput L4 Alteon",
  "design.alteon.throughput_l7": "Throughput L7 Alteon",
  "design.alteon.interfaces_and_type": "Interfaces Alteon",
  "design.alteon.ram_disk": "RAM/disco Alteon",
  "design.alteon.power_supply": "Fonte de alimentação Alteon",
  "design.alteon.cps_pps_concurrent_connections": "CPS/PPS Alteon",
  "design.alteon.ssl_capacity": "Capacidade SSL Alteon",
  "design.alteon.compression_throughput": "Throughput de compressão",
  "design.alteon.virtual_instances_partitions_route_domains": "Instâncias virtuais",
  "design.alteon.security_features": "Características de segurança",
  "design.alteon.management_visibility_features": "Gestão Alteon",
  "design.alteon.reporting_needs": "Relatórios Alteon",
  "design.alteon.logs_needs": "Logs Alteon",
  "design.alteon.storage_retention_needs": "Retenção Alteon",
  "design.application_security.deployment_model_cloud_onprem_both": "Modelo de implantação AppSec",
  "design.application_security.onprem_deployment_mode": "Modo on-prem AppSec",
  "design.application_security.ha_requirements": "HA AppSec",
  "design.application_security.throughput_l4": "Throughput L4",
  "design.application_security.throughput_l7": "Throughput L7",
  "design.application_security.interfaces_and_type": "Interfaces AppSec",
  "design.application_security.ram_disk": "RAM/disco AppSec",
  "design.application_security.power_supply": "Fonte de alimentação AppSec",
  "design.application_security.cps_pps_concurrent_connections": "CPS/PPS AppSec",
  "design.application_security.ssl_capacity": "Capacidade SSL AppSec",
  "design.application_security.number_of_applications": "Quantidade de aplicações",
  "design.application_security.number_of_apis": "Quantidade de APIs",
  "design.application_security.api_discovery_required": "Descoberta de APIs",
  "design.application_security.api_special_features": "Funções especiais de API",
  "design.application_security.bot_manager_required": "Gestão de bots",
  "design.application_security.sophisticated_bot_requirement_1": "Requisito avançado de bots 1",
  "design.application_security.sophisticated_bot_requirement_2": "Requisito avançado de bots 2",
  "design.application_security.client_side_protection_required": "Proteção do lado do cliente",
  "design.application_security.pci_certification_capabilities_required": "Capacidades PCI",
  "design.application_security.llm_firewall_required": "Firewall LLM",
  "design.application_security.ddos_requested_and_capacity": "DoS/DDoS AppSec e capacidade",
  "design.application_security.l7_ddos_requested": "DoS/DDoS L7",
  "design.application_security.management_visibility_features": "Gestão e visibilidade",
  "design.application_security.logs_needs": "Logs AppSec",
  "design.application_security.storage_retention_needs": "Retenção AppSec",
  "design.application_security.reporting_needs": "Relatórios AppSec",
  "design.application_security.ai_special_capabilities": "Capacidades de IA",
  "design.application_security.cdn_requirements": "Requisitos de CDN",
  "design.application_security.dns_hosted_zones": "Zonas DNS hospedadas",
  "design.application_security.dns_queries_per_month": "Consultas DNS mensais",
  "design.application_security.api_calls_or_requests_per_month": "Solicitações API mensais",
  "design.application_security.monthly_traffic_volume_tb_gb": "Volume de tráfego mensal",
  "design.application_security.total_http_https_requests_per_month": "Solicitações HTTP/HTTPS mensais",
  "design.global_management.centralized_management_required": "Gestão centralizada",
  "design.global_management.management_platform": "Plataforma de gestão",
  "design.global_management.managed_technologies": "Tecnologias gerenciadas",
  "design.global_management.deployment_model": "Modelo de implantação",
  "design.global_management.ha_requirements": "HA de gestão",
  "design.global_management.visibility_features": "Visibilidade",
  "design.global_management.reporting_needs": "Relatórios de gestão",
  "design.global_management.logs_needs": "Logs de gestão",
  "design.global_management.storage_retention_needs": "Retenção de gestão",
  "design.global_management.event_correlation": "Correlação de eventos",
  "design.global_management.forensic_analysis": "Análise forense",
  "design.global_management.rbac_or_user_roles": "RBAC / papéis de usuário",
  "design.global_management.audit_trail": "Trilha de auditoria",
  "design.global_management.integrations": "Integrações",
  "design.global_management.admin_access_and_resilience": "Acesso administrativo e resiliência",
  "design.global_management.licensing_or_scope_limits": "Licenciamento ou limites de escopo",
  "design.global_management.detection.flows_per_second": "Fluxos por segundo",
  "design.global_management.detection.routers_to_monitor": "Roteadores a monitorar",
  "design.global_management.detection.flow_protocols": "Protocolos de fluxo",
  "design.global_management.detection.prefixes_and_objects": "Prefixos e objetos",
  "design.global_management.detection.traffic_visibility_and_analytics": "Visibilidade e análise de tráfego",
  "design.global_management.detection.diversion_methods": "Métodos de desvio",
  "sti.support.number_of_years": "Período de suporte",
  "sti.support.rma_replacement_time": "Tempo de substituição RMA",
  "sti.support.under_attack_support_sla": "SLA sob ataque",
  "sti.support.solution_availability": "Disponibilidade da solução",
  "sti.support.support_availability": "Disponibilidade de suporte",
  "sti.support.special_customer_service_tam_csm_vendor_engineer": "Serviço especial ao cliente",
  "sti.training.certified_or_knowledge_transfer": "Tipo de treinamento",
  "sti.training.onsite_or_online": "Modalidade de treinamento",
  "sti.training.customer_facilities": "Local do treinamento",
  "sti.training.number_of_people": "Participantes",
  "sti.training.number_of_sessions": "Sessões de treinamento",
  "sti.implementation.vendor_implementation_required": "Implementação do fabricante",
  "sti.implementation.documentation_needs": "Documentação de implementação",
  "sti.implementation.attack_tests_required": "Testes de ataque",
  "sti.implementation.attack_test_requirements": "Requisitos de testes de ataque",
  "sti.implementation.vendor_engineer_certification_required": "Certificação do engenheiro do fabricante",
  "sti.implementation.partner_engineer_certification_required": "Certificação do engenheiro parceiro",
  "sti.implementation.delivery_timeline": "Cronograma de entrega",
  "commercial_admin.equipment_delivery_times": "Prazos de entrega",
  "commercial_admin.payment_terms": "Condições de pagamento",
  "commercial_admin.special_contractual_requirements": "Requisitos contratuais",
  "commercial_admin.acquisition_process_dates": "Datas do processo de aquisição",
  "commercial_admin.penalties": "Penalidades",
  "commercial_admin.offer_validity": "Validade da oferta",
  "commercial_admin.quote_submission_requirements": "Requisitos de cotação",
  "design.design_gaps": "Lacunas de design",
  "sti.sti_gaps": "Lacunas de suporte / treinamento / implementação",
  "commercial.commercial_admin_gaps": "Lacunas comerciais / administrativas",
};

export const GAP_AREA_LABELS_PT = {
  Design: "Design",
  "Support / Training / Implementation": "Suporte / Treinamento / Implementação",
  "Commercial / Administrative": "Comercial / Administrativo",
};
